import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { delayedExecution } from './delay';

interface Chat {
  id: string;
  title: string;
  is_favorite: boolean;
}

export const useChatNavigation = () => {
  const navigate = useNavigate();
  
  const navigateToChat = useCallback((chat: Chat) => {
    // Use delay utility to ensure navigation happens after current execution
    //todo need to review again
    delayedExecution(() => {
      navigate(`/chat?conversationId=${chat.id}`, { replace: false });
    }, 0);
  }, [navigate]);
  
  return { navigateToChat };
};

// More reliable navigation function with error handling
export const createChatNavigator = (chat: any, navigate: any) => {
  // Immediate validation
  if (!chat || !chat.id) {
    console.error('Invalid chat object:', chat);
    return;
  }
  
  if (!navigate || typeof navigate !== 'function') {
    console.error('Invalid navigate function:', navigate);
    // Direct fallback
    window.location.href = `/chat?conversationId=${chat.id}`;
    return;
  }
  
  try {
    // Try immediate navigation first
    navigate(`/chat?conversationId=${chat.id}`, { replace: false });
  } catch (error) {
    console.error('Immediate navigation failed:', error);
    
    // Retry with delay utility
    delayedExecution(() => {
      try {
        navigate(`/chat?conversationId=${chat.id}`, { replace: false });
      } catch (retryError) {
        console.error('Retry navigation failed:', retryError);
        // Final fallback
        window.location.href = `/chat?conversationId=${chat.id}`;
      }
    }, 50);
  }
};

// Alternative: Synchronous navigation with better error handling
export const navigateToChat = (chat: any, navigate: any) => {
  if (!navigate || typeof navigate !== 'function') {
    console.error('Invalid navigate function provided');
    return;
  }
  
  try {
    navigate(`/chat?conversationId=${chat.id}`);
  } catch (error) {
    console.error('Navigation failed:', error);
    // Fallback
    delayedExecution(() => {
      window.location.href = `/chat?conversationId=${chat.id}`;
    }, 100);
  }
};
